// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1EQFA","wrapper-nopadding":"wrapper-nopadding__apx-4","loading":"loading__2S8fP","error":"error__3SBr0","table-loading":"table-loading__fw8Ey","empty-val":"empty-val__3rrET","panelheader-tools":"panelheader-tools__3wN3A","propsPanels":"propsPanels__3bkZT","new":"new__12Hva","marginLm":"marginLm__W1YWg","marginRm":"marginRm__3JOhZ","fullWidth":"fullWidth__328Wb","fullHeight":"fullHeight__2P7hr","noData":"noData__1iGXM","form":"form__1RwzM","infos":"infos__3ciaK","info":"info__1Ml4N","submit":"submit__1Iso6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/ChannelView/coms/AddChannelForm/styles.scss
// module id = 2286
// module chunks = 1